import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "checkin-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Checkin Staff Page", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Validate Ticket", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Mark Ticket as Used")
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Wrong params to validate ticket :(", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.isValid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("p", null, [
                  _createVNode(_component_Button, { onClick: _ctx.handleMarkTicketUsed }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        ], 64))
      : (_openBlock(), _createElementBlock("p", _hoisted_9, "Loading..."))
  ]))
}